function GetAvailabilityCtrl($scope, halClient) {
    'ngInject';

    /***
     * @ngdoc method
     * @name loadAvailability
     * @methodOf BB:bbGetAvailability
     * @description
     * Load availability of the services in according of prms parameter
     *
     * @param {array} prms The parameters of availability
     */
    $scope.loadAvailability = (prms) => {

        const service = halClient.$get($scope.bb.api_url + '/api/v5/' + prms.company_id + '/services/' + prms.service);
        return service.then((serv) => {
                $scope.earliest_day = null;
                const sday = moment();
                const eday = moment().add(30, 'days');
                return serv.$get('days', {date: sday.toISOString(), edate: eday.toISOString()}).then(res =>
                    (() => {
                        const result = [];
                        for (const day of Array.from(res.days)) {
                            let item;
                            if ((day.spaces > 0) && !$scope.earliest_day) {
                                $scope.earliest_day = moment(day.date);
                                if (day.first) {
                                    item = $scope.earliest_day.add(day.first, 'minutes');
                                }
                            }
                            result.push(item);
                        }
                        return result;
                    })()
                );
            }
        );
    };
}

function getAvailabilityDirective() {
    'ngInject';

    return {
        restrict: 'AE',
        replace: true,
        scope: true,
        controller: GetAvailabilityCtrl,
        link(scope, element, attrs) {
            if (attrs.bbGetAvailability) {
                scope.loadAvailability(scope.$eval(attrs.bbGetAvailability));
            }
        }
    };
}

/***
 * @ngdoc directive
 * @name BB:bbGetAvailability
 * @restrict AE
 * @scope true
 *
 * @description
 *
 * Loads a list of availability for the currently in scope company
 *
 * <pre>
 * restrict: 'AE'
 * replace: true
 * scope: true
 * </pre>
 *
 * @property {array} earliest_day The availability of earliest day
 * @property {object} alert The alert service - see {@link BB:Alert Alert Service}
 */

angular
    .module('BB')
    .directive('bbGetAvailability', getAvailabilityDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/get-availability/get_availability.directive.js